{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.stmichael.softline",
  "name": "Softline"
}
